module.exports = __webpack_public_path__ + "static/media/1.9f5eded0.jpg";